"use strict";

var _slicedToArray = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var BlobImpl = require("./Blob-impl").implementation;

exports.implementation =
/*#__PURE__*/
function (_BlobImpl) {
  _inherits(FileImpl, _BlobImpl);

  function FileImpl(globalObject, _ref, privateData) {
    var _this;

    var _ref2 = _slicedToArray(_ref, 3),
        fileBits = _ref2[0],
        fileName = _ref2[1],
        options = _ref2[2];

    _classCallCheck(this, FileImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileImpl).call(this, globalObject, [fileBits, options], privateData));
    _this.name = fileName;
    _this.lastModified = "lastModified" in options ? options.lastModified : Date.now();
    return _this;
  }

  return FileImpl;
}(BlobImpl);